// Test/junk accounts kept out of every public discovery surface — Explore
// listings (/api/shops), Discover Barbers (/barbers), Community, and the
// owner/barber network talent feeds. Their rows stay in the database (and
// their direct profile URLs still resolve); this only stops them from being
// surfaced in feeds. Matching is exact on the display name, case-insensitive
// after trimming, so real accounts that merely contain one of these words
// (e.g. "Testaverde's Barbershop") are unaffected.
const BLOCKED_SHOP_NAMES = new Set([
  "barbershop demo",
  "suhai",
  "suhi",
  "bread loaf",
  "breadloaf",
  "jwxy2",
  // Shops attached to the April 2026 signup wave below. All four unpublished;
  // this keeps them out of discovery if one is ever published by accident.
  "grainger cuts",
  "mosop booth",
  "sparklin hair",
  "kelly stud",
  // The App Review demo shop. It must stay is_published = true — the review
  // notes walk a reviewer to its owner, and unpublished that step sends them
  // to a REAL barbershop, whose owner then gets a message from a stranger.
  // Blocking the name is how it leaves Explore, the job board and the sitemap
  // while its own page still resolves for the reviewer. Both spellings, so an
  // edit to the trailing "Co." can't quietly put it back in discovery.
  "halsted street barber co.",
  "halsted street barber co",
])
const BLOCKED_BARBER_NAMES = new Set([
  "test barber",
  "suhai",
  "suhi",
  "bread loaf",
  "breadloaf",
  "jwxy2",
  // Fabricated barbers seeded while building the network feed. The 1045
  // backfill published every barber row that existed, these among them, so
  // they surfaced in Talent and Community as if they were real people.
  "wei chen",
  "omar hassan",
  "jake sullivan",
  "carlos martinez",
  // Test accounts of ours, same reason.
  "apple john",
  "john apple",
  "pedro solis",
  "ramosdeduardo123",
  "max tester",
  "john doe",
  "ezekiel ramos",
  // April 2026 signup wave. Each has a display name with no relationship to
  // its email address, no photo, and a shop that was never published. Named by
  // the founder, who knows this cohort; recorded here so they stay out of
  // discovery and out of every mailer.
  "charles grainger",
  "mikel mosop",
  "yizaab sifa",
  "rodgers kelly",
])

function normalize(name: string | null | undefined): string {
  return (name || "").trim().toLowerCase()
}

export function isBlockedShopName(name: string | null | undefined): boolean {
  return BLOCKED_SHOP_NAMES.has(normalize(name))
}

export function isBlockedBarberName(name: string | null | undefined): boolean {
  return BLOCKED_BARBER_NAMES.has(normalize(name))
}
